/*=========================================================================================
  File Name: mutations.js
  Description: Vuex Store - mutations
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/


const mutations = {

  SET_STATE(state, payload) {
    const stateKeys = Object.keys(payload)
    stateKeys.forEach(key => {
      state[key] = payload[key]
    })
  },
  //user
  UPDATE_USER_INFO(state, payload) {
    for (const property of Object.keys(state.AppActiveUser)) {
      if (payload[property] !== undefined) {
        state.AppActiveUser[property] = payload[property]
      }
    }
    // Store data in localStorage
    localStorage.setItem("userInfo", JSON.stringify(state.AppActiveUser))
  },
  LOG_OUT(state) {
    localStorage.removeItem('userInfo')
    state.AppActiveUser = {
      id: '',
      userName: '',
      password: '',
      firstName: '',
      lastName: '',
      role: '',
      photoURL: ''
    }
  },
  PROFILE_AVATAR_UPLOADED(state, payload) {
    if (payload.context === 'user') {
      state.AppActiveUser['photoURL'] = payload.url
      localStorage.setItem("userInfo", JSON.stringify(state.AppActiveUser))
    } else if (payload.context === 'student') {
      let user = state.students.find(x => x.id === payload.id)
      user.imagePath = payload.url;
    } else if (payload.context === 'driver') {
      let user = state.drivers.find(x => x.id === payload.id)
      user.imagePath = payload.url;
    }
  },

  //students
  FETCH_STUDENTS(state, payload) {
    state.students = payload
  },
  STUDENT_CREATED(state, payload) {
    state.students.unshift(payload)
  },
  STUDENT_EDITED(state, payload) {
    const user = state.students.find(i => i.id === payload.id)
    state.students = state.students.filter(i => i.id !== payload.id)
    payload['imagePath'] = user.imagePath
    state.students.unshift(payload)
  },
  STUDENT_DELETED(state, payload) {
    state.students = state.students.filter(i => {
      return i.id !== payload.id
    })
  },

  //drivers
  FETCH_DRIVERS(state, payload) {
    state.drivers = payload.reverse()
  },
  FETCH_DEVICES(state, payload) {
    state.devices = payload
  },
  DRIVER_CREATED(state, payload) {
    state.drivers.unshift(payload)
  },
  DRIVER_UPDATED(state, payload) {
    let driver = state.drivers.find(x => x.id === payload.id)
    driver.trackId = payload.trackId;
    driver.deviceId = payload.deviceId;
  },
  DRIVER_EDITED(state, payload) {
    const user = state.drivers.find(i => i.id === payload.id)
    state.drivers = state.drivers.filter(i => i.id !== payload.id)
    payload['imagePath'] = user.imagePath
    state.drivers.unshift(payload)
  },
  DRIVER_DELETED(state, payload) {
    state.drivers = state.drivers.filter(i => {
      return i.id !== payload.id
    })
  },
  DEVICE_SAVED(state, payload) {
    let device = state.devices.find(x => x.id === payload.id)
    if (device)
      device.uniqueId = payload.uniqueId;
    else
      state.devices.push(payload);
  },

  //tasks
  FETCH_TASKS(state, payload) {
    state.tasks = payload.reverse()
  },
  TASK_RECEIVED(state, payload) {
    state.task = payload;
  },
  TASK_INFO_RECEIVED(state, payload) {
    state.taskInfo = payload;
  },
  STOP_LIVE_POSITIONS(state) {
    state.positions = []
    state.taskInfo = {id: null};
  },
  POSITIONS_RECEIVED(state, payload) {
    state.positions = payload
  },
  TASK_SAVED(state, payload) {
    let task = state.tasks.find(i => i.id === payload.id);
    if (task) {
      task.name = payload.name
    } else {
      state.tasks.unshift(payload)
    }
  },
  TASK_DELETED(state, payload) {
    state.tasks = state.tasks.filter(i => {
      return i.id !== payload.id
    })
  },
  CONSTRAINT_CREATED(state, payload) {
    state.task.constraints.push(payload)
    state.taskInfo.constraints.push(payload)
  },
  CONSTRAINT_DELETED(state, payload) {
    let index = state.task.constraints.findIndex(i => {
      return i.taskId === payload.taskId &&
        i.type === payload.constraintType &&
        i.userId1 === payload.userId1 &&
        i.userId2 === payload.userId2
    })
    state.task.constraints.splice(index, 1)
    state.taskInfo.constraints.splice(index, 1)
  },
  VALID_TIMES_SAVED(state, payload) {
    // Because of bad backend code I have to do this :(
    payload = payload.map(i => {
      return {dayNum: i.day, hour: i.hour, min: i.min}
    })
    state.task.validTimes = payload
  },
  TASK_MEMBER_ADDED(state, payload) {
    let user = state.students.find(i => i.id === payload.userId)
    user['taskLocationLatLong'] = payload.homeLocationLatLong
    user['taskLocationText'] = payload.homeLocationText
    state.task.members.push(user)
    state.taskInfo.usersWithNoService.push(user.id)
  },
  TASK_MEMBERS_ADDED(state, payload) {
    payload.forEach(p => {
      let user = state.students.find(i => i.id === p.userId)
      user['taskLocationLatLong'] = p.homeLocationLatLong
      user['taskLocationText'] = p.homeLocationText
      state.task.members.push(user)
      state.taskInfo.usersWithNoService.push(user.id)
    })

  },
  TASK_MEMBER_DELETED(state, payload) {
    if (state.tasks) {
      let task = state.tasks.find(i => i.id == payload.taskId)
      task.members = task.members.filter(i => i.id !== payload.userId)
    }
    if (state.task)
      state.task.members = state.task.members.filter(i => i.id !== payload.userId)
    if (state.taskInfo.usersWithNoService)
      state.taskInfo.usersWithNoService = state.taskInfo.usersWithNoService.filter(i => i !== payload.userId)
  },

  //services
  SERVICE_MEMBER_ADDED(state, payload) {
    let service = state.taskInfo.services.find(i => i.id === payload.serviceId)
    service.serviceMember.splice(payload.newIndex, 0, payload.user)
    state.taskInfo.usersWithNoService = state.taskInfo.usersWithNoService.filter(i => i !== payload.userId)
  },
  SERVICE_MEMBER_DELETED(state, payload) {
    let service = state.taskInfo.services.find(i => i.id === payload.serviceId)
    service.serviceMember = service.serviceMember.filter(i => i.id !== payload.userId)
    state.taskInfo.usersWithNoService.push(payload.userId)
  },
  SERVICE_DRIVER_ASSIGNED(state, payload) {
    let service = state.taskInfo.services.find(i => i.id === payload.serviceId)
    service.driver = state.drivers.find(i => i.id === payload.userId)
  },
  SERVICE_UPDATED(state, payload) {
    state.taskInfo.services.find(i => i.id === payload.serviceId).name = payload.name
  },
  SERVICE_CREATED(state, payload) {
    let service = {
      id: payload.id,
      name: payload.name,
      taskId: payload.taskId,
      driver: null,
      serviceMember: [],
      totalCost: 0,
    }
    state.taskInfo.services.push(service)
  },
  SERVICE_DELETED(state, payload) {
    let studentIds = state.taskInfo.services.find(i => i.id === payload.serviceId).serviceMember.map(i => i.id)
    state.taskInfo.usersWithNoService.push(...studentIds)
    state.taskInfo.services = state.taskInfo.services.filter(i => {
      return i.id !== payload.serviceId
    })
  },

  //messages
  USERS_WHO_NEED_MSG_CHANGED(state, payload) {

    switch (payload.action) {
      case 'add':
        state.usersWhoNeedMsg.unshift(payload.user)
        break
      case 'remove':
        state.usersWhoNeedMsg = state.usersWhoNeedMsg.filter(i => i.id !== payload.userId)
        break
      case 'update':
        state.usersWhoNeedMsg = payload.users
        break
    }

  },
  UNREAD_MESSAGES_CHANGED(state, payload) {
    state.unReadMessages = payload
  },
  MESSAGE_READ(state, messageId) {
    state.unReadMessages = state.unReadMessages.filter(i => i.id !== messageId)
  },

  //cohorts
  FETCH_COHORTS(state, payload) {
    state.cohorts = payload.reverse()
  },
  COHORT_CREATED(state, payload) {
    state.cohorts.unshift(payload)
  },
  COHORT_DELETED(state, payload) {
    state.cohorts = state.cohorts.filter(i => {
      return i.id !== payload.id
    })
  },
  COHORT_UPDATED(state, payload) {
    state.cohorts.find(i => i.id === payload.id).name = payload.name
  },
  USERS_ADDED_TO_COHORTS(state, {payload, context}) {
    payload.forEach(i => {
      let user = state[context].find(u => u.id === i.userId)
      let groups = state.cohorts.filter(x => i.groups.map(s => s.groupId).includes(x.id))
      user.groups = user.groups.concat(groups)
    })
  },
  USER_REMOVED_FROM_COHORT(state, payload) {
    if (payload.role === 'student') {
      let user = state.students.find(i => i.id === payload.userId)
      user.groups = user.groups.filter(i => i.id !== payload.groupId)
    } else if (payload.role === 'driver') {
      let user = state.drivers.find(i => i.id === payload.userId)
      user.groups = user.groups.filter(i => i.id !== payload.groupId)
    }
  },
  //lock
  USER_LOCK_CHANGED(state, payload) {
    if (payload.role === 'student') {
      let user = state.students.find(i => i.id === payload.userIds[0])
      user.locked = payload.lock;
    } else if (payload.role === 'driver') {
      let user = state.drivers.find(i => i.id === payload.userIds[0])
      user.locked = payload.lock;
    }
  },

  // /////////////////////////////////////////////
  // COMPONENTS
  // /////////////////////////////////////////////

  // Vertical NavMenu

  TOGGLE_IS_VERTICAL_NAV_MENU_ACTIVE(state, value) {
    state.isVerticalNavMenuActive = value
  },
  TOGGLE_REDUCE_BUTTON(state, val) {
    state.reduceButton = val
  },
  UPDATE_MAIN_LAYOUT_TYPE(state, val) {
    state.mainLayoutType = val
  },
  UPDATE_VERTICAL_NAV_MENU_ITEMS_MIN(state, val) {
    state.verticalNavMenuItemsMin = val
  },
  UPDATE_VERTICAL_NAV_MENU_WIDTH(state, width) {
    state.verticalNavMenuWidth = width
  },


  // VxAutoSuggest

  UPDATE_STARRED_PAGE(state, payload) {

    // find item index in search list state
    const index = state.navbarSearchAndPinList["pages"].data.findIndex((item) => item.url == payload.url)

    // update the main list
    state.navbarSearchAndPinList["pages"].data[index].is_bookmarked = payload.val

    // if val is true add it to starred else remove
    if (payload.val) {
      state.starredPages.push(state.navbarSearchAndPinList["pages"].data[index])
    } else {
      // find item index from starred pages
      const index = state.starredPages.findIndex((item) => item.url == payload.url)

      // remove item using index
      state.starredPages.splice(index, 1)
    }
  },

  // Navbar-Vertical

  ARRANGE_STARRED_PAGES_LIMITED(state, list) {
    const starredPagesMore = state.starredPages.slice(10)
    state.starredPages = list.concat(starredPagesMore)
  },
  ARRANGE_STARRED_PAGES_MORE(state, list) {
    let downToUp = false
    let lastItemInStarredLimited = state.starredPages[10]
    const starredPagesLimited = state.starredPages.slice(0, 10)
    state.starredPages = starredPagesLimited.concat(list)

    state.starredPages.slice(0, 10).map((i) => {
      if (list.indexOf(i) > -1) downToUp = true
    })

    if (!downToUp) {
      state.starredPages.splice(10, 0, lastItemInStarredLimited)
    }
  },


  // ////////////////////////////////////////////
  // UI
  // ////////////////////////////////////////////

  TOGGLE_CONTENT_OVERLAY(state, val) {
    state.bodyOverlay = val
  },
  UPDATE_PRIMARY_COLOR(state, val) {
    state.themePrimaryColor = val
  },
  UPDATE_THEME(state, val) {
    state.theme = val
  },
  UPDATE_WINDOW_WIDTH(state, width) {
    state.windowWidth = width
  },
  UPDATE_WINDOW_SCROLL_Y(state, val) {
    state.scrollY = val
  },


}

export default mutations

